import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/auth-context";
import { VenueSwitcherProvider } from "@/contexts/venue-switcher-context";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { DevAutoImpersonate } from "@/components/DevAutoImpersonate";
import LoginPage from "@/pages/auth/LoginPage";
import DevLoginPage from "@/pages/DevLoginPage";
import OtpVerifyPage from "@/pages/auth/OtpVerifyPage";
import MarketingPage from "@/pages/MarketingPage";
import GetStarted from "@/pages/GetStarted";
import OnboardingPage from "@/pages/OnboardingPage";
import AdminLayout from "@/components/AdminLayout";
import CampaignList from "@/pages/CampaignList";
import CampaignEditor from "@/pages/CampaignEditor";
import TVDisplay from "@/pages/TVDisplay";
import ReportPage from "@/pages/ReportPage";
import ROIAnalysisPage from "@/pages/ROIAnalysisPage";
import TemplatesPage from "@/pages/TemplatesPage";
import SuperAdminLayout from "@/components/SuperAdminLayout";
import CustomerListPage from "@/pages/admin/CustomerListPage";
import VenueDetailPage from "@/pages/admin/VenueDetailPage";
import UsersPage from "@/pages/admin/UsersPage";
import BrandingPage from "@/pages/BrandingPage";
import SettingsPage from "@/pages/SettingsPage";
import ManagementReportPage from "@/pages/ManagementReportPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <VenueSwitcherProvider>
          <AuthProvider>
            {import.meta.env.VITE_DEV_BYPASS === 'true' && <DevAutoImpersonate />}
            <Routes>
              {import.meta.env.DEV && <Route path="/dev-login" element={<DevLoginPage />} />}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/verify-otp" element={<OtpVerifyPage />} />
              <Route path="/" element={import.meta.env.VITE_DEV_BYPASS === 'true' ? <Navigate to="/admin" replace /> : <MarketingPage />} />
              <Route path="/get-started" element={<GetStarted />} />
              <Route path="/app/welcome" element={<OnboardingPage />} />
              <Route path="/app" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<CampaignList />} />
                <Route path="campaigns/new" element={<CampaignEditor />} />
                <Route path="campaigns/:id/edit" element={<CampaignEditor />} />
                <Route path="campaigns/:id/report" element={<ReportPage />} />
                <Route path="campaigns/:id/roi" element={<ROIAnalysisPage />} />
                <Route path="campaigns/:id/management-report" element={<ManagementReportPage />} />
                <Route path="templates" element={<TemplatesPage />} />
                <Route path="branding" element={<BrandingPage />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
              <Route path="/admin" element={<ProtectedRoute><SuperAdminLayout /></ProtectedRoute>}>
                <Route index element={<CustomerListPage />} />
                <Route path="venues/:venueId" element={<VenueDetailPage />} />
                <Route path="users" element={<UsersPage />} />
              </Route>
              <Route path="/display/:id" element={<TVDisplay />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </VenueSwitcherProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);
export default App;
